import React from 'react';

import useApi from '@/hooks/useApi';
import { useSlider } from '@/hooks/useSlider';

import { dispatchInteraction } from '@/services/requests/Interactions/helpers';
import { TInteractionCardClick } from '@/services/requests/Interactions/types';

import { getVisibleCardsIdByElement } from '@/helpers/HtmlHelper/getVisibleCardsIdByElement';

import { Card } from './Card';
import { TSliderProps } from './interface';
import { ButtonsSlider } from './ButtonSlider';

export const Slider = ({ data, tabName, tabActive }: TSliderProps) => {
  const { id, cards } = data;

  const filteredCards = data.cards.filter(card => card.type !== '["tag"]');

  const { Api } = useApi();
  const { sliderState, moveSlider, containerRef, checkScrollLimit } = useSlider(
    { ...data, cards: filteredCards },
    tabName,
    tabActive,
    data.layout,
  );

  async function handleCardClick(
    event: React.MouseEvent<HTMLAnchorElement>,
    cardId: string,
  ) {
    event.preventDefault();

    await dispatchInteraction<TInteractionCardClick>(Api, 'card-click', {
      recommendationId: id,
      tabName,
      cardId,
      cardPosition: cards.findIndex(item => item.id === cardId) + 1,
      cards: getVisibleCardsIdByElement(
        containerRef.current as HTMLElement,
        'card-click',
      ),
    });

    return true;
  }

  return (
    <div className="vitrine-template1__slider">
      <>
        <ButtonsSlider
          handleClick={e => moveSlider(e)}
          sliderScroll={sliderState.scroll}
          checkScrollLimit={checkScrollLimit}
        />
        <div
          className="vitrine-template1__cards"
          ref={containerRef}
          data-testid="cards"
        >
          {filteredCards.map(card => (
            <Card
              key={card.id}
              data={card}
              onClick={e => handleCardClick(e, card.id)}
              showButton={!!data.config.show_cta_card_btn}
              recommendationId={id}
            />
          ))}
        </div>
      </>
    </div>
  );
};
